import moment from 'moment';
import Store from '../store/store';

export const encodeString = (str) => {
  return encodeURI(String(str));
};

export const getUniqueID = () => {
  return Date.now();
};

export const getPreSignedUrl = async function (key, fileName) {
  const url = `${process.env.VUE_APP_DATA_API}/signed-url/${encodeString(
    `${key}_${getUniqueID()}`
  )}.${fileName.split('.')[1]}`;

  const myHeaders = new Headers();
  myHeaders.append(
    'Authorization',
    'Bearer ' + Store.state.user.signInUserSession.accessToken.jwtToken
  );

  myHeaders.append('content-type', 'application/json');

  const preSignedPayload = {
    filePath: fileName,
    prefix: 'output',
  };

  try {
    const preSignedRes = await fetch(url, {
      headers: myHeaders,
      body: JSON.stringify(preSignedPayload),
      method: 'POST',
    });

    if (preSignedRes.status === 200) return await preSignedRes.json();
    throw new Error(preSignedRes);
  } catch (err) {
    throw new Error(err);
  }
};

export const uploadFile = async function (signedUrl, file) {
  const formData = new FormData();
  formData.append('Content-Type', signedUrl['signature']['Content-Type']);
  formData.append('Policy', signedUrl['signature']['Policy']);
  formData.append('X-Amz-Algorithm', signedUrl['signature']['X-Amz-Algorithm']);
  formData.append(
    'X-Amz-Credential',
    signedUrl['signature']['X-Amz-Credential']
  );
  formData.append('X-Amz-Date', signedUrl['signature']['X-Amz-Date']);
  formData.append('X-amz-signature', signedUrl['signature']['X-amz-signature']);
  formData.append('acl', signedUrl['signature']['acl']);
  formData.append('bucket', signedUrl['signature']['bucket']);
  formData.append('key', signedUrl['signature']['key']);
  formData.append(
    'success_action_status',
    signedUrl['signature']['success_action_status']
  );
  formData.append('file', file);

  return await fetch(`https:${signedUrl['postEndpoint']}`, {
    body: formData,
    method: 'POST',
  });
};

export const isObjectType = (element) => {
  return element && typeof element === 'object' && !Array.isArray(element);
};

export const timestampToCETConvertor = (timestamp, dateFormat = null) => {
  const date = moment.tz(timestamp, 'Europe/Berlin').lang('de');
  if (dateFormat) {
    return date.format(dateFormat);
  }
  return date.format().split('+')[0];
};

export const getCETTimeStampFromDate = (date) => {
  return moment.tz(date, 'Europe/Berlin').valueOf();
};

export const convertDateToCETDate = (date) => {
  return moment.tz(date, 'Europe/Berlin');
};

export const convertDateToUTCIgnoringTimezone = (date) => {
  const timestamp = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  );

  return new Date(timestamp);
};

export const convertDatewithUTCTimezone = (utcDate, timezonOffset = 60) => {
  const timezoneOffsetInMilliseconds = timezonOffset * 60 * 1000;
  const dateWithTimezone = new Date(
    utcDate.getTime() - timezoneOffsetInMilliseconds
  );
  return dateWithTimezone;
};

export const utcToZonedTime = (utcDate, timezone = 'Europe/Berlin') => {
  return new Date(
    utcDate.toLocaleString('en-US', {
      timeZone: timezone,
    })
  );
};

export const getTimezoneDifference = (date, timezone = 'Europe/Berlin') => {
  return moment.tz(date, timezone).format('Z');
};

export const changeDateStringLocaleToDe = (date) => {
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
  };
  return date.toLocaleString('de-DE', options);
};

export const debouncer = (
  func,
  timeout = 1500,
  context,
  contextVariable = 'debounceTimer'
) => {
  if (context[contextVariable]) {
    clearTimeout(context[contextVariable]);
  }
  context[contextVariable] = setTimeout(() => {
    func.apply(this);
  }, timeout);
};

export const getFlowLastId = (context) => {
  if (context.lastID == null) {
    context.lastID = Math.round(Math.random() * 100000 + new Date().getTime());
    return context.lastID;
  } else {
    ++context.lastID;
    return context.lastID;
  }
};

export const getFlowTaskDataObject = ({
  itemLabel = '',
  fileKey = '',
} = {}) => {
  return {
    id: new Date().getTime(),
    name: 'Start',
    caption: 'Start',
    icon: 'fa fa-play',
    ui: 'Start',
    active: true,
    shape: {
      type: 'circle',
      x: 500,
      y: 300,
      width: 99,
      height: 99,
      selected: false,
    },
    props: {
      trigger: 'formTrigger',
      timeTrigger: { freq: 'H', date: '01.03.2020', time: '08:00' },
      formTrigger: {
        elements: [
          {
            label: itemLabel,
            name: itemLabel,
            id: generateRandomId(),
            type: 'model',
            value: '' + fileKey + '',
            options: [],
            attributes: { required: true },
          },
        ],
      },
      eventTrigger: null,
      emailTrigger: null,
    },
    input: [],
    output: [],
    previousTaskId: null,
  };
};

export const getWizardData = () => {
  const wizardStyles = `<style>
    .button-wrapper #prevbtn,.button-wrapper #nextbtn {
        cursor: pointer;
        color: rgba(255, 255, 255, 0.951);
        border: 3px solid rgba(0, 0, 0, 0.916);
        background-color: rgba(0, 0, 0, 0.916);
        border-radius: 0.375em;
        font-weight: 400;
        line-height: 23px;
        padding: 0.5rem 1.5rem;
        font-size: 0.9375rem;
        margin: 25px 0px 25px 0px;
        letter-spacing: 0.6px;
        margin-right: 20px;
        min-width: 105px;
        text-transform: capitalize;
    }
  
    .button-wrapper #prevbtn:not([disabled]):hover,
    .button-wrapper #nextbtn:not([disabled]):hover {
      color: #fff;
      border: 3px solid #353434;
      background-color: #353434;
    }

    .wizard-tab-container .wizard-title {
      color: #5f697a;
      text-transform: capitalize;
      font-weight: 500;
      display: flex;
      align-items: center;
      font-size: 22px;
      margin-bottom: 30px;
    }

    .wizard-progress-wrapper .horizontal-steps {
      position: relative;
      width: 100%;
      height: auto;
      font-family: "Helvetica";
      font-size: 14px;
      margin-top: 50px;
    }

    .wizard-progress-wrapper .step-progress {
      position: relative;
      padding-left: 0;
      list-style: none;
      height: 100%;
      display: flex;
      justify-content: space-between;
    }

    .wizard-progress-wrapper .step-progress li {
      display: inline-block;
      z-index: 1;
      padding-bottom: 30px;
      flex-grow: 1;
      color: black;
    }

    .wizard-progress-wrapper .step-progress-item {
      position: relative;
    }

    /* .wizard-progress-wrapper .step-progress-item.current span{
      border
    } */

    .wizard-progress-wrapper .step-progress-item span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      background-color: white;
      position: relative;
      z-index: 1;
      background: #d6d5d6;
      padding: 3px
    }

    .wizard-progress-wrapper .step-progress-item span .step-container {
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    .wizard-progress-wrapper .step-progress-item img {
      width: 30px;
      height: auto;
    }

    .wizard-progress-wrapper .step-progress-item:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 28%;
      left: 0;
      height: 3px;
      width: 110%;
      background-color: #d6d5d6;
      z-index: 0;
    }

    .wizard-progress-wrapper .step-progress-item::after {
      /*content: attr(data-string);*/
      font-size: 12px;
      display: block;
      z-index: 1;
      position: absolute;
      top: 45px;
      left: unset;
      right: 0;
      text-align: left;
      width: 100%;
      color: black;
      font-weight: 300;
      font-family: sans-serif;
    }

    .wizard-progress-wrapper .step-progress-item.current span {
      background: var(--primary-brand-color-dark);
    }

    .wizard-progress-wrapper .step-progress-item.is-done span {
      background: var(--primary-brand-color-dark);
    }

    .wizard-progress-wrapper .step-progress-item:not(:last-child).is-done::before {
      background-color: var(--primary-brand-color-dark);
    }

    .wizard-progress-wrapper .step-progress-item:last-child {
      flex-grow: 0;
    }

    @media(max-width: 767px){
      .wizard-tab-container input[type="text"] {width: 100%;}
    
      .button-wrapper #prevbtn, .button-wrapper #nextbtn,.button-wrapper #submit-btn {
          min-width: 74px;
          padding: 0.5rem 10px;
      }
      
      .button-wrapper {
          justify-content: center;
      }

      #codelosForm {
        width: 80%;
      }

      .wizard-tab-container .wizard-title {
        font-size: 7px;
        word-break: break-all;
      }

      .wizard-progress-wrapper .step-progress li {
        min-width: 40px;
      }

      .wizard-progress-wrapper .step-progress-item img {
        width: 25px;
      }

      .wizard-progress-wrapper .step-progress-item span {
        width: 30px;
        height: 30px;
      }

      .wizard-progress-wrapper
        .step-progress-item:not(:last-child)::before {
        top: 24%;
      }

      .wizard-progress-wrapper .step-progress {
        flex-direction: column;
      }

      .wizard-progress-wrapper
        .step-progress-item:not(:last-child)::before {
        width: 3px;
        height: 100%;
        left: 13px;
      }
      .wizard-progress-wrapper {
        width: 50px;
        float: left;
      }

      .wizard-tab-container {
        width: calc(100% - 50px);
        margin-left: auto;
      }

      .wizard-progress-wrapper .horizontal-steps {
        margin-top: 0;
      }
      
      .button-wrapper {
        flex-wrap: wrap;
      }
    }
  </style>`;

  const wizardScript = ` <script id='codelos-wizard-script'>
  const wizardTabs = document.querySelectorAll("div.title");
  const codelosForm = document.getElementById("codelosForm");
  let submitFormText = null;
  let hiddenInputElement;
  let wizardTabsObject = {};
  let currentStep = 0;
  let isProgressBarVisible = {isProgressBarVisible}; 

  function progressBarDisplayer(stepID) {
    const ProgressBarSteps = document.querySelectorAll(
      ".wizard-progress-wrapper .step-progress-item"
    );

    for (let index = 0; index < ProgressBarSteps.length; index++) {
      const element = ProgressBarSteps[index];

      if (index !== stepID) {
        element.classList.remove("is-done");
        element.classList.remove("current");

        if (index < stepID) {
          element.classList.add("is-done");
        }
      } else {
        element.classList.remove("is-done");
        element.classList.add("current");
      }
    }
  }

  function tabDisplayer(tabID) {
    isProgressBarVisible && progressBarDisplayer(tabID);
    const tabs = Object.keys(wizardTabsObject);
    tabs.map((el, index) => {
      let wizardtab = document.getElementById("wizardtab" + index);

      if (index === tabID) {
        wizardtab.style.display = "block";
      } else {
        wizardtab.style.display = "none";
      }
    });
  }

  function validator() {
    const tabs = Object.keys(wizardTabsObject);
    const elementsArray = wizardTabsObject[tabs[currentStep]];

    if (!elementsArray || !elementsArray.length) return true;

    let isValid = true;

    const throwError = () => {
      isValid = false;
      document.getElementById("submit-btn").click();
    }

    const getObjectListContainers = (element) => {
      let objectListContainers = [];

      if (element.getAttribute("data-object-list") === "true") {
        objectListContainers.push(element);
      } else {
        objectListContainers = element.querySelectorAll(
          '[data-object-list="true"]'
        );
      }

      return objectListContainers;
    };

    for (let index = 0; index < elementsArray.length; index++) {
      let element = elementsArray[index];
      const unwatedTags = ['SCRIPT', 'STYLE'];

      if (!unwatedTags.includes(element.tagName)) {
        if (!isValid) break;

        if (element.tagName !== 'INPUT') {
          const accordionLabel = element.querySelector('.accordion-list-label');

          if (accordionLabel && accordionLabel !== null && accordionLabel.tagName.toLowerCase() === 'label' && accordionLabel.getAttribute('aria-expanded') === "false") {
            accordionLabel.click();
            isValid = false;
          }

          let elementArr = element.querySelectorAll('input, textarea');

          for (let j = 0; j < elementArr.length; j++) {
            const wrapperdElement = elementArr[j];
            if (!isValid) break;

            if (wrapperdElement.type === 'checkbox') {
              if (wrapperdElement.dataset?.minCheckedLength && wrapperdElement.dataset?.cardElement) {
                if (wrapperdElement.required) {
                  isValid = false;
                  const labelElement = wrapperdElement?.parentNode?.parentNode?.querySelector("label." + wrapperdElement.name);
                  if (labelElement) {
                    const container = document.getElementById(wrapperdElement.name);
                    container.scrollIntoView({ behavior: 'smooth' });
                    callToaster("Please select minimum " + wrapperdElement.dataset.minCheckedLength + " " + labelElement.innerText);
                  }
                  break;
                }

              } else {
                if (wrapperdElement.required && wrapperdElement.checked === false) {
                  throwError();
                }
              }

            } else if (wrapperdElement.required && (!wrapperdElement.checkValidity() || wrapperdElement.value.trim() === "")) {
              const objectListContainers = getObjectListContainers(element);

              if (objectListContainers && objectListContainers.length) {

                for (let ObjectIndex = 0; ObjectIndex < objectListContainers.length; ObjectIndex++) {
                  const objectListDiv = objectListContainers[ObjectIndex];

                  if (objectListDiv) {
                    if (objectListDiv.contains(wrapperdElement)) {
                      if (!wrapperdElement.hasAttribute('disabled') || (wrapperdElement.hasAttribute('disabled') && wrapperdElement.getAttribute('disabled') === 'false')) {
                        isValid = false;
                        break;
                      }
                    } else {
                      throwError();
                      break;
                    }
                  }
                }
              } else {
                throwError();
              }
            } else if ( wrapperdElement.required && wrapperdElement.checkValidity() && (wrapperdElement.disabled === false || !wrapperdElement.hasAttribute("disabled"))) {
              const objectListContainers = getObjectListContainers(element);
              if (objectListContainers && objectListContainers.length) {
                for (let ObjectIndex = 0; ObjectIndex < objectListContainers.length; ObjectIndex++) {
                  const objectListDiv = objectListContainers[ObjectIndex];
                  if (objectListDiv) {
                    if (objectListDiv.contains(wrapperdElement)) {
                      if(!wrapperdElement?.classList?.contains('checkbox-validation')){
                        isValid = false;
                        break;
                      }
                    }
                  }
                }
              }
            }
          }

        } else {
          if (element.required && element.value.trim() === "") {
            throwError();
          }
        }
      }
    }

    return isValid;
  }

  function onPrevButtonClick() {
    const tabs = Object.keys(wizardTabsObject);

    if (currentStep - 1 === 0) {
      const prevbtn = document.getElementById("prevbtn");
      prevbtn.style.opacity = "0.6";
      prevbtn.disabled = "true";

      const nextbtn = document.getElementById("nextbtn");
      nextbtn.innerHTML = "nächste";
    } else {
      const nextbtn = document.getElementById("nextbtn");
      const submitbtn = document.getElementById("submit-btn");
      nextbtn.style.opacity = "1";
      nextbtn.disabled = "";
      nextbtn.innerHTML = "nächste";
      submitbtn.style.display = "none";
    }

    currentStep = currentStep - 1;

    tabDisplayer(currentStep);
  }
  function onNextButtonClick() {
    if (validator()) {
      const tabs = Object.keys(wizardTabsObject);
      if (currentStep + 1 === tabs.length - 1) {
        const nextbtn = document.getElementById("nextbtn");
        nextbtn.innerHTML = submitFormText !== null ? submitFormText : "Starten";

        const prevbtn = document.getElementById("prevbtn");
        prevbtn.style.opacity = "1";
        prevbtn.disabled = "";
      } else if (currentStep + 1 > tabs.length - 1) {
        const submitbtn = document.getElementById("submit-btn");
        return submitbtn.click()
      } else {
        const prevbtn = document.getElementById("prevbtn");
        prevbtn.style.opacity = "1";
        prevbtn.disabled = "";
      }
      currentStep = currentStep + 1;

      tabDisplayer(currentStep);
    }
  }

  function injectButtons() {
    const buttonArray = [
      {
        id: "prevbtn",
        click: onPrevButtonClick,
        text: "Zurück",
        type: "button",
      },
      {
        id: "nextbtn",
        click: onNextButtonClick,
        text: "Weiter",
        type: "button",
      },
      { id: "submit-btn", text: "Starten", type: "submit" },
    ];

    const buttonWrapper = document.createElement("div");
    buttonWrapper.setAttribute("class", "button-wrapper");
    buttonWrapper.style.display = "flex";

    buttonArray.map((props) => {
      let button = document.createElement("button");
      button.innerHTML = props.text;
      button.setAttribute("id", props.id);
      button.setAttribute("type", props.type);
      if (props.click) {
        button.addEventListener("click", props.click);
      }
      if (props.id === "prevbtn") {
        button.style.opacity = "0.6";
        button.disabled = "true";
      }

      if (props.id === "submit-btn") {
        button.style.display = "none";
      }
      buttonWrapper.appendChild(button);
    });
    codelosForm.appendChild(buttonWrapper);
    codelosForm.appendChild(hiddenInputElement);
  }

  function injectHtml() {
    const tabsArr = Object.keys(wizardTabsObject);

    tabsArr.map((el, index) => {
      const tab = document.createElement("div");
      tab.setAttribute("id", "wizardtab" + index);
      tab.setAttribute("class", "wizard-tab-container");

      const titleDiv = document.createElement("div");
      titleDiv.setAttribute("class", "wizard-title");
      titleDiv.innerHTML = el;

      tab.appendChild(titleDiv);

      if (index > 0) {
        tab.style.display = "none";
      }
      wizardTabsObject[el].map((elements) => {
        tab.appendChild(elements);
      });
      codelosForm.appendChild(tab);
    });

    injectButtons();
  }

  function injectProgressBar() {
    const progressWrapper = document.createElement('div');
    progressWrapper.setAttribute("class", "c-wrap mb-3 wizard-progress-wrapper");
    let progressBar = '<div class="horizontal-steps"><ul class="step-progress">';
    for (let index = 0; index < wizardTabs.length; index++) {
      progressBar += '<li data-string={tab_titel} class="step-progress-item no-select' + (index === 0 ? ' current' : '') + '"><span><div class="step-container">' + (index + 1) + '</div></span></li>'
    }
    progressBar += '</ul></div>';
    progressWrapper.innerHTML = progressBar;
    codelosForm.appendChild(progressWrapper);
  }

  function createTabs() {
    wizardTabsObject = {};
    for (let index = 0; index < wizardTabs.length; index++) {
      const headerElement = wizardTabs[index];
      let sibling = headerElement.nextElementSibling;
      let siblingElements = [];

      while (sibling !== null && sibling !== wizardTabs[index + 1]) {
        siblingElements.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      let arrayElements;

      if (index === wizardTabs.length - 1) {
        let customSubmitBtn = siblingElements.find((el) => el.id === "custom-submit-btn");
        if (customSubmitBtn) {
          submitFormText = customSubmitBtn.innerHTML;
        }
        arrayElements = siblingElements.filter(
          (el) => !(el.id == "submit-btn" || el.id == "custom-submit-btn")
        );
      } else {
        arrayElements = siblingElements;
      }

      wizardTabsObject[headerElement.innerHTML] = arrayElements;
    }

    setTimeout(() => {
      hiddenInputElement = document.getElementsByName("id")[0];
      codelosForm.innerHTML = "";
      isProgressBarVisible && injectProgressBar();
      injectHtml();
    }, 10);
  }

  setTimeout(() => {
    createTabs();
  }, 10)
</script>`;

  const wizardData = [
    { name: 'wizardstyles', value: wizardStyles },
    { name: 'wizardscript', value: wizardScript },
  ];

  const defaultHtmlObject = {
    name: 'html',
    label: 'HTML ',
    placeholder: 'HTML',
    type: 'html',
    value: '',
    layoutItem: true,
    isWizardTemplate: true,
  };

  const wizardHtmlArray = wizardData.map((el) => {
    const tempObj = { ...defaultHtmlObject };
    tempObj.value = el.value;
    tempObj.name = el.name;
    tempObj.label = el.name;
    return tempObj;
  });

  return wizardHtmlArray;
};

export const mergeArray = (Array1, Array2, commanID) => {
  const mergedMap = new Map();

  Array1.forEach((item) => {
    mergedMap.set(item[commanID], { ...item });
  });

  Array2.forEach((item) => {
    if (mergedMap.has(item[commanID])) {
      mergedMap.set(item[commanID], {
        ...mergedMap.get(item[commanID]),
        ...item,
      });
    } else {
      mergedMap.set(item[commanID], { ...item });
    }
  });

  return Array.from(mergedMap.values());
};

const hexToRgb = (hex) =>
  ((value) =>
    value.length === 3
      ? value.split('').map((c) => parseInt(c.repeat(2), 16))
      : value.match(/.{1,2}/g).map((v) => parseInt(v, 16)))(
    hex.replace('#', '')
  );

export const isHexTooDark = (hexColor) =>
  (([r, g, b]) => 0.2126 * r + 0.7152 * g + 0.0722 * b < 40)(
    hexToRgb(hexColor)
  );

export const isHexTooLight = (hexColor) =>
  (([r, g, b]) => (r * 299 + g * 587 + b * 114) / 1000 > 155)(
    hexToRgb(hexColor)
  );

export const trimImage = (img, width, height) => {
  const tempCanvas = document.createElement('canvas');
  const tempCtx = tempCanvas.getContext('2d');

  tempCanvas.width = width;
  tempCanvas.height = height;
  tempCtx.drawImage(img, 0, 0);

  const trimmedCanvas = trimCanvas(tempCanvas, width, height);

  return trimmedCanvas.toDataURL();
};

function trimCanvas(canvas, width, height) {
  const ctx = canvas.getContext('2d');
  const pixels = ctx.getImageData(0, 0, width, height).data;
  let top = height;
  let bottom = 0;
  let left = width;
  let right = 0;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const index = (y * width + x) * 4;
      if (pixels[index + 3] > 0) {
        if (x < left) left = x;
        if (x > right) right = x;
        if (y < top) top = y;
        if (y > bottom) bottom = y;
      }
    }
  }
  const trimWidth = right - left + 1;
  const trimHeight = bottom - top + 1;
  const trimmedCanvas = document.createElement('canvas');
  trimmedCanvas.width = trimWidth;
  trimmedCanvas.height = trimHeight;
  const trimmedCtx = trimmedCanvas.getContext('2d');
  trimmedCtx.drawImage(
    canvas,
    left,
    top,
    trimWidth,
    trimHeight,
    0,
    0,
    trimWidth,
    trimHeight
  );
  return trimmedCanvas;
}

export const formatTablename = (str) => {
  return str
    .replace(/ /g, '-')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue');
};

export const dummyProcessTaskObject = (name, icon, props, id) => {
  return {
    id: new Date().getTime() + id,
    active: true,
    visible: true,
    name: 'CustomCode',
    caption: name,
    status: 'success',
    icon: icon
      ? icon
      : 'https://res.cloudinary.com/gharnati-com/image/upload/v1681824477/noun-electricity-4806795_shvk5m.png',
    ui: 'CustomCode',
    shape: {
      type: 'rectangle custom-task',
      x: 300,
      y: 500,
      width: 215,
      height: 72,
    },
    input: null,
    props: props,
    output: null,
  };
};

export const jsonParser = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return null;
  }
};

export const getApiEndpointVersion = (url) => {
  if (url.includes('127.0.0.1') || url.includes('localhost')) {
    return null;
  }
  const versionMatch = url.match(/(?:\/v|\.ebv)(\d+)/i);
  if (versionMatch) {
    const version = parseInt(versionMatch[1], 10);
    return version;
  }
  return 0;
};

export const isValidTaskName = (name) => {
  const namePattern = /^[a-zA-Z0-9_]+$/;

  return namePattern.test(name);
};

export const generateRandomId = () => {
  return Math.round(
    Math.random() * 100000 + new Date().getTime() - Math.random()
  );
};

export const getSliderValuePosition = (slider, label) => {
  const sliderRect = slider.getBoundingClientRect();
  const labelRect = label.getBoundingClientRect();
  const sliderWidth = sliderRect.width;
  const labelWidth = labelRect.width;

  let minValue = isNaN(parseInt(slider.min, 10)) ? 0 : parseInt(slider.min, 10);
  let maxValue = isNaN(parseInt(slider.max, 10))
    ? 100
    : parseInt(slider.max, 10);
  let currentValue = parseInt(slider.value, 10);
  if (minValue > 0) {
    maxValue = maxValue - minValue;
    currentValue = currentValue - minValue;
    minValue = 0;
  }
  const thumbPosition = (currentValue - minValue) / (maxValue - minValue);
  // Determine the correction factor
  const halfMaxValue = (maxValue - minValue) / 2;
  let correctionFactor = 0;
  let offset;
  if (currentValue < minValue + halfMaxValue) {
    // If in the first half of the slider, adjust to the right
    correctionFactor = (halfMaxValue - currentValue) / halfMaxValue;
    correctionFactor *= -10;
    offset = 18;
  } else {
    // If in the second half of the slider, adjust to the left
    correctionFactor = (currentValue - halfMaxValue) / halfMaxValue;
    correctionFactor *= 10;
    offset = 12;
  }
  if (currentValue === minValue) {
    offset = 10;
  }
  // Scale the correction factor by a constant to adjust its effect
  // Apply the correction factor depending on the thumb position
  let labelLeftPosition =
    sliderWidth * thumbPosition - labelWidth / 2 - correctionFactor;
  // Prevent the label from overflowing the slider's bounds
  labelLeftPosition = Math.max(labelLeftPosition, 0);
  labelLeftPosition = Math.min(labelLeftPosition, sliderWidth - labelWidth);
  return labelLeftPosition + offset;
};

export const checkDeviceIsLaptop = async () => {
  if ('getBattery' in navigator) {
    const battery = await navigator.getBattery();
    if (battery.charging && battery.chargingTime === 0) {
      return false;
    } else {
      return true;
    }
  }
  return false;
};

export const generateUUID = (length = 32) => {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
  let uuid = '';

  for (let i = 0; i < length; i++) {
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += '-';
    }
    uuid += chars[Math.floor(Math.random() * chars.length)];
  }

  return uuid;
};
export const getCheckboxMinMax = (element) => {
  const min =
    element?.settings?.min !== '' && element?.settings?.min !== undefined
      ? element.settings.min
      : 0;
  const max =
    element?.settings?.max !== '' && element?.settings?.max !== undefined
      ? element.settings.max
      : element.options.length;
  return {
    min,
    max,
  };
};

export const getDataApiVersion = (database) => {
  if (
    Store?.state?.paginationDbs &&
    Store.state.paginationDbs.includes(database)
  ) {
    return 'v8';
  }
  return 'v7';
};

/**
 * Recursively input data fields and flattens nested objects into an array of key-value pairs.
 *
 * @param {string} name - The key name of the current field.
 * @param {any} value - The value associated with the key.
 * @returns {Array<{ name: string, value: any }>} An array of objects containing field names and values.
 */
export const flattenInputObjectFields = (name, value) => {
  const fields = [];
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    if (
      !(
        value?.hasOwnProperty('props') &&
        value?.props?.hasOwnProperty?.('htmlContent') &&
        value?.props?.hasOwnProperty?.('jsonContent')
      )
    ) {
      fields.push({
        name: `${name}`,
        value: value,
      });
    }
  } else {
    fields.push({
      name: `${name}`,
      value: value,
    });
  }
  if (
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    !(
      value?.hasOwnProperty('props') &&
      value?.props?.hasOwnProperty?.('htmlContent') &&
      value?.props?.hasOwnProperty?.('jsonContent')
    )
  ) {
    for (const objKey in value) {
      if (value.hasOwnProperty(objKey)) {
        const nestedFields = flattenInputObjectFields(
          `${name}:${objKey}`,
          value[objKey]
        );
        fields.push(...nestedFields);
      }
    }
  }

  return fields;
};

/**
 * This function retrieves a placeholder value from an array of input objects.
 *
 * @param {string} name - The placeholder string to be replaced.
 * @param {Array<{ name: string, value: any }>} inputs An array of objects containing name and value properties.
 * @returns {string}  The corresponding value if found, otherwise the original placeholder.
 */
export const getPlaceHolderValue = (placeholder, inputs = []) => {
  const match = placeholder.match(/^\{(.+?)\}$/);
  if (!match) return placeholder;

  const [rootKey, ...restPlaceholder] = match[1].split(':');
  const dataItem = inputs.find((item) => item.name === rootKey);
  if (!dataItem || ['codelosSettings', 'dataframe'].includes(dataItem.type))
    return placeholder;

  const resolveValue = (segments, value) => {
    for (const key of segments) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key];
      } else {
        return placeholder;
      }
    }
    return value;
  };

  return resolveValue(restPlaceholder, dataItem.value);
};

export const getInputPlaceholderList = (
  taskInputs,
  apiVersion = 7,
  typesToFilter = [],
  includeName = false
) => {
  typesToFilter.push('dataframe');
  if (apiVersion <= 7) {
    if (taskInputs)
      return [...taskInputs]
        .filter(
          (item) =>
            item.name !== 'codelosSettings' &&
            !typesToFilter.includes(item.type)
        )
        .map((item) => {
          return includeName
            ? { name: item.name, label: item.label }
            : { name: item.label };
        });
  } else {
    const dropDownItems = [];
    if (taskInputs) {
      const filteredInputs = [...taskInputs].filter(
        (item) =>
          item.name !== 'codelosSettings' && !typesToFilter.includes(item.type)
      );
      filteredInputs.forEach((e) => {
        if (e.value && typeof e.value === 'object' && !Array.isArray(e.value)) {
          let processedFields = flattenInputObjectFields(e.name, e.value);
          if (includeName) {
            processedFields = processedFields.map((field) => ({
              ...field,
              label: field.name,
            }));
          }
          dropDownItems.push(...processedFields);
        } else {
          if (includeName) {
            dropDownItems.push({
              name: e.name,
              label: e.label,
              value: e.value,
            });
          } else {
            dropDownItems.push({ name: e.label, value: e.value });
          }
        }
      });

      return dropDownItems;
    }
  }
  return [];
};

export const LATEST_FLOW_RUNNER_VERSION = 8;
/**
 * Formats a date to Central European Time (CET) using the specified format.
 *
 * @param {Date|string|number} date - The date to format. Can be a Date object,
 *                                  a date string, or a timestamp.
 * @param {string} dateFormat - The format string to use for formatting the date.
 *                            Default is 'MM.DD.YYYY hh:mm A'.
 * @returns {string} - The formatted date string in CET timezone.
 *
 */
export const getFormattedCETTime = (
  date,
  dateFormat = 'MM.DD.YYYY hh:mm A'
) => {
  return moment.utc(date).tz('CET').format(dateFormat);
};

export const showInputInvalidCustomMessage = (event) => {
  try {
    const inputElement = event.target;
    const { validity, value, type, min, max } = inputElement;
    const emailPattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

    if (type === 'email' && value && !emailPattern.test(value)) {
      inputElement.setCustomValidity(
        'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
      );
    } else if (validity.patternMismatch) {
      inputElement.setCustomValidity(
        'Bitte passen Sie das angeforderte Format an.'
      );
    } else if (validity.rangeOverflow && max !== '') {
      inputElement.setCustomValidity(
        `Der Wert muss kleiner oder gleich ${max} sein.`
      );
    } else if (validity.rangeUnderflow && min !== '') {
      inputElement.setCustomValidity(
        `Der Wert muss größer oder gleich ${min} sein.`
      );
    } else if (['date', 'datetime-local'].includes(type) && validity.badInput) {
      inputElement.setCustomValidity(
        'Bitte geben Sie einen gültigen Wert ein. Das Feld ist unvollständig oder hat ein ungültiges Datum.'
      );
    } else if (validity.valueMissing) {
      inputElement.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
    } else {
      inputElement.setCustomValidity('');
    }
  } catch (error) {
    return;
  }
};

export const extractValueFromInputPath = (inputPath, taskInputs) => {
  try {
    if (!inputPath || !taskInputs || !Array.isArray(taskInputs)) return null;

    const parts = inputPath.split(':');
    const rootKey = parts.shift();

    const matchedItem = taskInputs.find((item) => item.name === rootKey);
    if (!matchedItem || !matchedItem.value) return null;

    let current = matchedItem.value;
    for (const part of parts) {
      if (current && typeof current === 'object' && part in current) {
        current = current[part];
      } else {
        return null;
      }
    }

    return current;
  } catch (error) {
    return null;
  }
};

export const getInterpolatedValue = (inputStr, taskInputs) => {
  try {
    if (
      inputStr &&
      inputStr[0] === '{' &&
      inputStr[inputStr.length - 1] === '}'
    ) {
      const nameToFind = inputStr.slice(1, -1);
      const matchedInput = taskInputs.find(
        (item) =>
          item.name === nameToFind &&
          item.name !== 'codelosSettings' &&
          item.name !== 'dataframe' &&
          item.type !== 'JSON'
      );
      if (nameToFind.includes(':') && !matchedInput) {
        return extractValueFromInputPath(nameToFind, taskInputs) || inputStr;
      }
      if (['modal', 'custom'].includes(matchedInput?.name)) {
        return matchedInput?.value?.id;
      }

      return matchedInput?.value;
    }

    return inputStr;
  } catch (error) {
    return inputStr;
  }
};

export const resetVuex = () => {
  Store.state.user = null;
  Store.state.userSettings = null;
  Store.state.flows = [];
  Store.state.addNewFlowPermission = false;
  Store.state.databaseList = [];
  Store.state.workflowsPerTag = [];
  Store.state.paginationDbs = [];
  Store.state.tagsPerWorkflow = {};
  Store.state.isAdmin = false;
  Store.state.databaseItems = {};
};
export const formatWithThousandSeparator = (value) => {
  const number = Number(value);
  if (isNaN(number)) return value;
  return number.toLocaleString('de-DE');
};
